import React from "react";
import {Page} from "../../components/page/page";
import styles from "./aspect.module.css";
import {ChooseButton} from "../../components/choose-button/choose-button";
import {Link} from "react-router-dom";
import {setAspect} from "../../store/stateSlice";
import {useDispatch} from "react-redux";

const AscpectPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Which aspect of your life do you wish to get astrological insights about?"
      hideContinueButton={true}
      currentStep={1}
    >
      <ul className={styles.list}>
        <li>
          <Link to={"../your-birthdate"}>
            <ChooseButton icon="💞" onClick={() => dispatch(setAspect("love"))}>love</ChooseButton>
          </Link>
        </li>
        <li>
          <Link to={"../your-birthdate"}>
            <ChooseButton icon="👩‍⚕️" onClick={() => dispatch(setAspect("health"))}>health</ChooseButton>
          </Link>
        </li>
        <li>
          <Link to={"../your-birthdate"}>
            <ChooseButton icon="💼" onClick={() => dispatch(setAspect("career"))}>career</ChooseButton>
          </Link>
        </li>
        <li>
          <Link to={"../your-birthdate"}>
            <ChooseButton icon="💸" onClick={() => dispatch(setAspect("money"))}>money</ChooseButton>
          </Link>
        </li>
      </ul>
    </Page>
  );
};

export { AscpectPage };
